import apiClient, { API_BASE_URL } from './apiClient';

// ============================================================
// Types — matching backend Go models (d202)
// ============================================================

export interface FD120 {
  fd120_01: string;        // 繳庫單號 (PK)
  fd120_11: string | null; // 繳庫日期 (ISO string)
  fd120_12: string;        // 廠商代號
  fd120_13: number;        // 繳庫類別 (1=正常, 2=異常)
  fd120_14: string;        // 庫位
  fd120_15: number;        // 含稅旗標
  fd120_16: number;        // 稅額
  fd120_17: string;        // 部門
  fd120_18: string;        // 幣別
  fd120_19: number;        // 匯率
  fd120_20: number;        // 未稅金額
  fd120_201: number;       // 含稅總額
  fd120_21: string;        // 採購單號
  fd120_22: string;
  fd120_23: string;        // 異常代碼
  fd120_24: number;        // 原料/半成品/成品
  fd120_241: boolean;
  fd120_25: string | null;
  fd120_26: number;
  fd120_27: string;
  fd120_28: string | null;
  fd120_29: string;
  fd120_30: string | null;
  fd120_32: number;        // 明細總項數
  fd120_33: number;
  fd120_34: number;
  fd120_35: string;        // 入布時間
  fd120_36: string | null; // 預計驗貨日期
  fd120_37: string;        // 預計驗貨時間
  fd120_38: string | null;
  fd120_39: string;
  fd120_40: string;        // 備註
  fd120_41: string;        // 異常說明
  fd120_42: boolean;
  fd120_43: string | null;
  fd120_44: string;
  fd120_45: boolean;       // 三聯式發票
  fd120_46: string;        // 內部交運出貨單號
  fd120_47: number;
  fd120_48: boolean;
  fd120_49: number;
  fd120_491: number;
  fd120_80: string;        // 核准狀態 (N/P)
  fd120_81: string;
  fd120_87: string;
  fd120_88: string | null;
  fd120_89: string;
  fd120_90: number;        // Version
  fd120_91: string;        // 輸單人員
  fd120_92: string | null;
  fd120_93: string;
  fd120_94: string;
  fd120_324: number;

  // Associations
  details?: FD121[];
  abnormals?: FD125[];
}

export interface FD121 {
  fd121_01: string;   // 繳庫單號 (FK)
  fd121_02: number;   // 項次
  fd121_10: string;   // 產品代號1
  fd121_11: string;   // 產品代號2
  fd121_12: string;   // 產品名稱
  fd121_13: number;   // PO項次
  fd121_14: string;   // 等級代號
  fd121_141: string;
  fd121_15: number;   // 繳庫數量
  fd121_16: string;   // 繳庫單位
  fd121_17: number;   // 繳庫單價
  fd121_171: number;
  fd121_172: number;
  fd121_18: number;   // 繳庫金額
  fd121_181: number;
  fd121_19: string;   // ASSORT (Y/N)
  fd121_20: number;   // 單位換算率
  fd121_21: string;   // 異常旗標
  fd121_22: number;
  fd121_23: number;
  fd121_24: string;   // 幅寬1
  fd121_25: string;   // 幅寬2
  fd121_26: string;   // 幅寬3
  fd121_27: string;   // 幅寬4
  fd121_28: string;   // 庫存單位
  fd121_29: string;   // SC NO
  fd121_30: number;   // SC SEQ
  fd121_31: string;   // 產品規格
  fd121_32: string;   // 加工別
  fd121_33: number;   // 幅寬值1
  fd121_34: number;
  fd121_35: number;
  fd121_36: number;
  fd121_37: number;
  fd121_38: number;   // 累計繳庫量
  fd121_39: string;
  fd121_40: boolean;
  fd121_41: number;   // 包缸費
  fd121_411: number;
  fd121_90: number;   // Version

  // Sub-detail associations
  colors?: FD122[];
}

export interface FD122 {
  fd122_01: string;   // 繳庫單號
  fd122_02: number;   // 行號
  fd122_03: number;   // 色號序號
  fd122_11: string;   // 色號
  fd122_111: string;  // 色名1
  fd122_112: string;  // 色名2 (英文)
  fd122_11a: string;
  fd122_12: number;   // 顏色繳庫數量
  fd122_13: number;   // 包缸費
  fd122_131: number;
  fd122_14: number;
  fd122_15: string;
  fd122_16: number;   // 採購單顏色序號
  fd122_17: string;
  fd122_18: string;
  fd122_19: string;   // 異常代碼
  fd122_20: number;
  fd122_21: number;   // 累計繳庫量
  fd122_22: number;   // 單位換算率
  fd122_23: boolean;
  fd122_24: boolean;
  fd122_90: number;   // Version

  // Sub-detail associations
  plates?: FD123[];
  sizes?: FD126[];
}

export interface FD123 {
  fd123_01: string;   // 繳庫單號
  fd123_02: number;   // 行號
  fd123_03: number;   // 色號序號
  fd123_04: number;   // 材質順序
  fd123_11: string;   // 板號
  fd123_12: string;   // 缸號
  fd123_13: string;
  fd123_90: number;   // Version
}

export interface FD126 {
  fd126_01: string;   // 繳庫單號
  fd126_02: number;   // 行號
  fd126_03: number;   // 色號序號
  fd126_11: string;   // 尺寸代號
  fd126_12: number;   // 數量
}

export interface FD125 {
  fd125_01: string;   // 繳庫單號
  fd125_02: number;   // 序號
  fd125_11: string;   // 項數
  fd125_12: string;   // 異常說明代號
  fd125_13: string;   // 異常說明
  fd125_14: string;   // 預計作業日期
  fd125_91: string;
  fd125_92: string;
  fd125_93: string;
  fd125_15: number;   // 單據流水號
}

// ============================================================
// Request / Response types
// ============================================================

export interface D202ListResponse {
  data: FD120[];
  total: number;
  page: number;
  size: number;
}

export interface D202CreateRequest {
  master: Partial<FD120>;
  details: Partial<FD121>[];
  colors: Partial<FD122>[];
  plates: Partial<FD123>[];
  sizes: Partial<FD126>[];
  abnormals: Partial<FD125>[];
}

export interface D202SearchResult {
  receipt_no: string;
  supplier_code: string;
  supplier_name: string;
  receipt_date: string | null;
  po_no: string;
  warehouse: string;
  currency: string;
}

export interface D202SearchResponse {
  data: D202SearchResult[];
  total: number;
  page: number;
  size: number;
}

export interface ApprovalResponse {
  receipt_no: string;
  action: string;
  old_status: string;
  new_status: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const d202Api = {
  async search(keyword: string, page = 1, size = 20): Promise<D202SearchResponse> {
    const params: Record<string, string | number> = { keyword, page, size };
    const res = await apiClient.get('/api/d202/search', { params });
    return res.data;
  },

  async list(page = 1, size = 20): Promise<D202ListResponse> {
    const res = await apiClient.get('/api/d202', { params: { page, size } });
    return res.data;
  },

  async get(receiptNo: string): Promise<FD120> {
    const res = await apiClient.get(`/api/d202/${encodeURIComponent(receiptNo)}`);
    return res.data;
  },

  async previewFromPurchaseOrder(poNo: string): Promise<FD120> {
    const res = await apiClient.get(`/api/d202/from-po/${encodeURIComponent(poNo)}`);
    return res.data;
  },

  async previewFromInternalShipment(shipmentNo: string): Promise<FD120> {
    const res = await apiClient.get(`/api/d202/from-internal-shipment/${encodeURIComponent(shipmentNo)}`);
    return res.data;
  },

  async create(data: D202CreateRequest): Promise<FD120> {
    const res = await apiClient.post('/api/d202', data);
    return res.data;
  },

  async update(receiptNo: string, data: D202CreateRequest): Promise<FD120> {
    const res = await apiClient.put(`/api/d202/${encodeURIComponent(receiptNo)}`, data);
    return res.data;
  },

  async delete(receiptNo: string): Promise<void> {
    await apiClient.delete(`/api/d202/${encodeURIComponent(receiptNo)}`);
  },

  // Approve: POST /api/d202/:id/approve
  async approve(receiptNo: string, comment?: string): Promise<ApprovalResponse> {
    const res = await apiClient.post(`/api/d202/${encodeURIComponent(receiptNo)}/approve`, { comment: comment || '' });
    return res.data;
  },

  // Submit for approval: POST /api/d202/:id/submit
  async submitForApproval(receiptNo: string): Promise<{ message: string }> {
    const res = await apiClient.post(`/api/d202/${encodeURIComponent(receiptNo)}/submit`);
    return res.data;
  },

  // Reject: POST /api/d202/:id/reject
  async reject(receiptNo: string, comment?: string): Promise<{ message: string }> {
    const res = await apiClient.post(`/api/d202/${encodeURIComponent(receiptNo)}/reject`, { comment: comment || '' });
    return res.data;
  },

  // Writeoff: POST /api/d202/:id/writeoff
  async writeoff(receiptNo: string, comment?: string): Promise<{ message: string }> {
    const res = await apiClient.post(`/api/d202/${encodeURIComponent(receiptNo)}/writeoff`, { comment: comment || '' });
    return res.data;
  },

  // Get approval history: GET /api/d202/:id/history
  async getApprovalHistory(receiptNo: string): Promise<ApprovalEvent[]> {
    const res = await apiClient.get(`/api/d202/${encodeURIComponent(receiptNo)}/history`);
    return res.data.events || [];
  },

  // Get print URL with token
  getPrintUrl(receiptNo: string): string {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
    return `${API_BASE_URL}/api/d202/${encodeURIComponent(receiptNo)}/print?token=${encodeURIComponent(token)}`;
  },

  // Lookup: get display name for a reference table code
  // type: employee | supplier | department | currency | warehouse | grade
  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/d202/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};

// ============================================================
// Approval history types
// ============================================================

export interface ApprovalEvent {
  action: string;
  user: string;
  date: string | null;
  note: string;
}
